import React from "react";
import { Navigate } from "react-router-dom";
import { Alert, Box } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { isSuperAdmin } from "../../utils/roles";

export default function SuperAdminRoute({ children }) {
  const { user } = useAuth();

  if (!isSuperAdmin(user)) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="warning">
          Esta sección es solo para el superadministrador de WebProfit.
        </Alert>
        <Navigate to="/dashboard" replace />
      </Box>
    );
  }

  return children;
}
